<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">
    <h3>Actualización de Stock</h3>
    <button class="btn btn-primary my-2" (click)="add()"><i class="fas fa-plus-circle me-2"></i>Registrar Nueva
        Actualización</button>
    <br>
    <kuv-lazy-table url={{url}} [pageSize]="20" [headers]="sesion.headers" [reloadEmitter]="reloadEmitter"
        [urlExcel]="config.apiUrl + 'actualizacion-stock/excel'" [headersBlob]="sesion.headersBlob" [filtros]="filtros"
        [columnas]="columnas" [acciones]="acciones" [useIndex]="true" [isRounded]="true"
        [hasShadow]="true"></kuv-lazy-table>
</div>